@if (!loginDisplay) {
  <div class="wrapper-dark">
    <mat-card class="login-box">
      <mat-card-title>Sign In</mat-card-title>
      <img mat-card-image src="assets/images/niq_dark.png" alt="NielsenIQ" />
      <mat-card-content class="progress-message">
        @if (loading) {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Loading resources. Please wait...</p>
          </div>
        } @else {
          <ng-template #elseBlock>
            <p>Use your NielsenIQ credentials.</p>
          </ng-template>
        }
        @if (!loading && !success) {
          <div class="spacer"></div>
        }
      </mat-card-content>
      <mat-card-actions>
        @if (!loading && !success) {
          <button
            class="niq-button-dark"
            [autofocus]="false"
            (click)="loginRedirect()"
          >
            Login
          </button>
        }
      </mat-card-actions>
    </mat-card>
  </div>
} @else {
  <main>
    <mat-toolbar color="primary">
      <a mat-button [routerLink]="['channels']">
        <mat-icon>tv</mat-icon>
        <span>PLASMA</span>
      </a>
      <span class="spacer"></span> Primary Lookups And Service Managing
      Application Table Values
      <span class="spacer"></span>
      @if (loginDisplay) {
        <button mat-raised-button (click)="logout()">Logout</button>
      }
    </mat-toolbar>
    <section class="content">
      <div class="monitor">
        @if (!isIframe) {
          <router-outlet></router-outlet>
        }
      </div>
    </section>
  </main>
}
